import { render, staticRenderFns } from "./ToplistCorporateItem.vue?vue&type=template&id=618c5440&"
import script from "./ToplistCorporateItem.vue?vue&type=script&lang=js&"
export * from "./ToplistCorporateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports